import { getMostValuedResources } from '@/services/StatisticsService'

import { isError } from '../../utils/api'
import { getStatisticsService } from '../../utils/statistics'

export default {
  state: {
    schools: [],
    abilityDevelopmentLoading: false,
    abilityDevelopment: [],
    aspectOfMostValuedResourcesLoading: false,
    aspectOfMostValuedResources: [],
    approachByCategoryLoading: false,
    approachByCategory: [],
    chosenMethodologiesLoading: false,
    chosenMethodologies: [],
    skillsPerCategoryLoading: false,
    skillsPerCategory: [],
    mostValuedResourcesLoading: false,
    mostValuedResources: {
      page: 0,
      totalPages: 0,
      resources: [],
      nextPage: 0
    }
  },

  mutations: {
    setLoading(state, { resource, status }) {
      state[`${resource}Loading`] = status
    },
    setSchools(state, schools) {
      state.schools = schools
    },
    setAspectByCategory(state, info) {
      state.aspectOfMostValuedResources = info
    },
    setApproachByCategory(state, info) {
      state.approachByCategory = info
    },
    setChosenMethodologies(state, info) {
      state.chosenMethodologies = info
    },
    setSkillsPerCategory(state, info) {
      state.skillsPerCategory = info
    },
    setMostValuedResources(state, info) {
      state.mostValuedResources = {
        ...info,
        resources: [
          ...state.mostValuedResources.resources,
          ...info.resources
        ]
      }
    },
    resetMostValuedResources(state) {
      state.mostValuedResources = {
        page: 0,
        totalPages: 0,
        resources: [],
        nextPage: 0
      }
    }
  },

  actions: {
    async hydrateSchools({ commit, rootState }) {
      const StatisticsService = await getStatisticsService(rootState.userInfo.userInfo)
      const response = await StatisticsService.getSchools()
      commit('setSchools', response.data)
    },
    async getAspectsToDisplay({ commit, rootState }, payload) {
      try {
        commit('setLoading', { resource: 'aspectOfMostValuedResources', status: true })
        const StatisticsService = getStatisticsService(rootState.userInfo.userInfo)
        const response = await StatisticsService.getResourcesMoreValuedByFilters(payload)
        commit('setAspectByCategory', response.data)
        commit('setLoading', { resource: 'aspectOfMostValuedResources', status: false })
      } catch (error) {
        commit('setAspectByCategory', [])
      }
    },
    async getApproachToDisplay({ commit, rootState }, payload) {
      try {
        commit('setLoading', { resource: 'approachByCategory', status: true })
        const StatisticsService = getStatisticsService(rootState.userInfo.userInfo)
        const response = await StatisticsService.getApproachByCategoryInfo(payload)
        commit('setApproachByCategory', response.data)
        commit('setLoading', { resource: 'approachByCategory', status: false })
      } catch (error) {
        commit('setApproachByCategory', [])
      }
    },
    async getChosenMethodologies({ commit, rootState }, payload) {
      try {
        commit('setLoading', { resource: 'chosenMethodologies', status: true })
        const StatisticsService = getStatisticsService(rootState.userInfo.userInfo)
        const response = await StatisticsService.getChosenMethodologies(payload)
        commit('setChosenMethodologies', response.data)
        commit('setLoading', { resource: 'chosenMethodologies', status: false })
      } catch (error) {
        commit('setChosenMethodologies', [])
      }
    },
    async loadMostValuedResources({ commit, rootState }, { pageSize, pageNumber = 0, clean }) {
      if (clean) commit('resetMostValuedResources')
      const response = await getMostValuedResources({ pageSize, pageNumber }).catch(e => e.response)
      if (!isError(response.status)) {
        const info = {
          resources: response.data.data,
          totalPages: response.data.totalPages,
          page: response.data.pageNumber + 1
        }
        commit('setMostValuedResources', info)
      } else {
        commit('resetMostValuedResources')
      }
    },
    async getSkillsPerCategory({ commit, rootState }, payload) {
      try {
        commit('setLoading', { resource: 'skillsPerCategory', status: true })
        const StatisticsService = getStatisticsService(rootState.userInfo.userInfo)
        const response = await StatisticsService.getChosenSkills(payload)
        commit('setSkillsPerCategory', response.data)
        commit('setLoading', { resource: 'skillsPerCategory', status: false })
      } catch (error) {
        commit('setSkillsPerCategory', [])
      }
    },
    async hydrateStatistics({ dispatch, commit }) {
      dispatch('hydrateSchools')
      commit('setLoading', { resource: 'mostValuedResources', status: true })
      await dispatch('loadMostValuedResources', { pageSize: 4 })
      await dispatch('loadMostValuedResources', { pageSize: 4, pageNumber: 1 })
      commit('setLoading', { resource: 'mostValuedResources', status: false })
    }
  },

  getters: {
    getSchoolsOptions: state => state.schools.map(school => ({ value: school.id, label: school.name })),
    getAspectOfMostValuedResources: state => state.aspectOfMostValuedResources.map(
      aspect => ({ category: aspect.reviewCategory, value: aspect.percentage })
    ),
    getApproachByCategory: state => state.approachByCategory.map(
      approach => ({ category: approach.categoryName, value: approach.percentage })
    ),
    getMappedChosenMethodologies: state => state.chosenMethodologies.map(elem => ({ category: elem.methodology, value: elem.percentage }))
  }
}
